export const RECAPTCHA = {
  siteKey: '6LdA9bwZAAAAADe16Ysz-a4tiv8-PYv_q-ERF7Yo',
};

export const COOKIE_LANG = 'pref_lang';

export const COOKIE_DOMAIN =
  window.location.href.indexOf('localhost') !== -1
    ? 'localhost'
    : '.geneplanet.com';
